<script setup lang="ts">
import { HttpError } from '../utilities/error'
throw new HttpError(404, 'Not Found')
</script>
